import { render, staticRenderFns } from "./SubCuentas.vue?vue&type=template&id=843a34d2&scoped=true"
import script from "./SubCuentas.vue?vue&type=script&lang=js"
export * from "./SubCuentas.vue?vue&type=script&lang=js"
import style0 from "./SubCuentas.vue?vue&type=style&index=0&id=843a34d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843a34d2",
  null
  
)

export default component.exports